import React, { useEffect, useState } from "react";
import { supabase } from "../../supabaseClient";
import LoaderBox from "../HomePage/LoaderBox";
import TrainIcon from "../../Assets/Icons/train.png";
import BusIcon from "../../Assets/Icons/bus.png";
import CarIcon from "../../Assets/Icons/car.png";
import WalkingIcon from "../../Assets/Icons/walking.png";
import Navigation from "../Navigation/Navigation";
import HomeFooter from "../HomePage/HomeFooter";

const HowToCome = () => {
  const [loading, setLoading] = useState(true);
  const [data, setData] = useState(null);

  useEffect(() => {
    fetchHowToData();
  }, []);

  const fetchHowToData = async () => {
    try {
      const { data: dbData, error } = await supabase
        .from("how_to_come")
        .select("*")
        .single();

      if (error) throw error;
      setData(dbData);
    } catch (error) {
      console.error("Greška pri dohvaćanju lokacije:", error.message);
    } finally {
      setLoading(false);
    }
  };

  if (loading) return <LoaderBox text="Učitavanje..." />;
  if (!data) return null;

  return (
    <>
      <Navigation />
      <div className="how-to-come-container">
        <i className="fi fi-rs-marker"></i>
        <h3>{data.title}</h3>
        {data.subtitle && <p className="subtitle">{data.subtitle}</p>}
        {data.intro_description && <p>{data.intro_description}</p>}

        <div className="htc-grid">
          {/* KARTICA: AUTOMOBILOM */}
          {data.car_text && (
            <div className="htc-card">
              <div className="card-icon">
                <img src={CarIcon} alt="Auto" />
              </div>
              <h3>Automobilom</h3>
              <p>{data.car_text}</p>

              {/* Dinamički gumbi za parking/mape */}
              <div className="btn-group-how-to">
                {data.car_buttons?.map((btn) => (
                  <a
                    key={btn.id}
                    href={btn.link}
                    target="_blank"
                    rel="noreferrer"
                    className="parking-badge free action-link"
                  >
                    <i className="fi fi-rs-marker"></i> {btn.label}
                  </a>
                ))}
              </div>
            </div>
          )}

          {/* JAVNI PRIJEVOZ */}
          {(data.transport_text || data.transport_lines?.length > 0) && (
            <div className="htc-card">
              <img src={BusIcon} alt="Bus" />
              <h3>Javni prijevoz</h3>
              <p>{data.transport_text}</p>

              {data.transport_lines?.map((line) => (
                <div key={line.id} className="card-info">
                  <h5>{line.num}</h5>
                  <div className="arrival-info">
                    <h6>Polazak:</h6> <span>{line.from}</span>
                  </div>
                  <div className="arrival-info">
                    <h6>Stanica:</h6> <span>{line.to}</span>
                  </div>
                </div>
              ))}
            </div>
          )}

          {/* VLAK (HŽ) */}
          {(data.train_text || data.train_lines?.length > 0) && (
            <div className="htc-card">
              <img src={TrainIcon} alt="Vlak" />
              <h3>HŽ Vlak</h3>
              <p>{data.train_text}</p>
              {data.train_lines?.map((train) => (
                <div key={train.id} className="train-info-row">
                  <div className="parking-badge info">
                    <i className="fi fi-rs-train-side"></i> {train.name}
                  </div>
                  <p className="sub-detail">
                    Silazak: <strong>{train.station}</strong>
                  </p>
                </div>
              ))}
            </div>
          )}

          {/* BICIKL & PJEŠICE */}
          {data.walking_text && (
            <div className="htc-card">
              <img src={WalkingIcon} alt="Pješak" />
              <h3>Biciklom & Pješice</h3>
              <p>{data.walking_text}</p>
            </div>
          )}
        </div>

        {/* SEKCIJA S KARTOM */}
        {data.map_iframe && (
          <div className="map-container">
            <div className="map-overlay-info">
              <h3>Lokacija turnira</h3>
              <p>Vidimo se na terenu!</p>
            </div>
            <div className="iframe-wrapper">
              {/* Iframe se renderira direktno iz baze */}
              <div dangerouslySetInnerHTML={{ __html: data.map_iframe }} />
            </div>
          </div>
        )}
      </div>
      <HomeFooter />
    </>
  );
};

export default HowToCome;
